import * as z from 'zod';

import { simulatorStateSchema } from '@/domain/schema';
import type { SimulatorState } from '@/domain/types';

const envelopeSchema = z.object({
  exportedAt: z.string(),
  version: z.string(),
  scenarioName: z.string().optional(),
  state: simulatorStateSchema,
});

export function exportToFile(state: SimulatorState): void {
  const envelope = {
    exportedAt: new Date().toISOString(),
    version: state.version,
    scenarioName: state.info?.title?.trim() || 'Mon scénario',
    state,
  };
  const blob = new Blob([JSON.stringify(envelope, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `saas-sim-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function parseImportFile(file: File): Promise<SimulatorState> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const raw: unknown = JSON.parse(e.target?.result as string);
        const result = envelopeSchema.safeParse(raw);
        if (!result.success) {
          reject(new Error("Le fichier n'est pas un export valide de SaaS Pricing Simulator."));
          return;
        }
        resolve(result.data.state);
      } catch {
        reject(new Error('Le fichier JSON est malformé ou illisible.'));
      }
    };
    reader.onerror = () => reject(new Error('Impossible de lire le fichier.'));
    reader.readAsText(file);
  });
}
